import { InertiaLink } from "@inertiajs/inertia-react";
import { InertiaLinkProps } from "@inertiajs/react";
import React from "react";

export interface LegacyLinkProps extends React.HTMLProps<HTMLAnchorElement> {
  legacy?: boolean;
}

export interface LinkProps extends InertiaLinkProps {
  legacy?: boolean;
}

// !REMINDER: This is a legacy link component that will be replaced by InertiaLink
const Link = ({ legacy = true, children, ...props }: any) =>
  legacy ? (
    <a href="#" {...props}>
      {children}
    </a>
  ) : (
    <InertiaLink {...props}>{children}</InertiaLink>
  );

export default Link;
